import fetch from 'auth/FetchInterceptor'

const PanelsService = {}

PanelsService.fetch = function () {
	return fetch({
		url: '/panels',
		method: 'get'
	})
}

PanelsService.create = function (data) {
	return fetch({
		url: '/panels',
		method: 'post',
		data
	})
}

PanelsService.update = function (data) {
	return fetch({
		url: '/panels/' + data.id,
		method: 'put',
		data
	})
}

PanelsService.delete = function (id) {
	return fetch({
		url: '/panels/' + id,
		method: 'delete'
	})
}

export default PanelsService;